/**
 * Inline Creation Schema — Expense Type
 *
 * Used by relation resolution when an activity references an expense type
 * that does not exist yet.
 */

import { UploadSchema } from '../types';

export const v2ExpenseTypeSchema: UploadSchema = {
	entityType: 'v2ExpenseType',
	label: 'Expense Type',
	apiEndpoint: '/v1/expense-types',
	apiMethod: 'POST',
	payloadTransform: (formValues, projectId) => ({
		name: formValues.name,
		project: projectId,
	}),
	fields: [
		{
			name: 'name',
			label: 'Expense Type Name',
			dataType: 'string',
			required: true,
			headerAliases: ['Expense Type', 'Expenditure Type', 'Cost Type'],
		},
	],
};
